/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { createContext, useContext, useRef, type ReactNode } from "react";
import {
  DismissButton,
  Overlay,
  usePopover,
  type AriaPopoverProps,
} from "react-aria";
import type { OverlayTriggerState } from "react-stately";

import { cssFns } from "@superweb/css";

export const MaxHeightContext = createContext<string | number | undefined>(
  undefined,
);
export const useMaxHeightContext = () => useContext(MaxHeightContext);

export const Popover = (
  props: {
    children: ReactNode;
    state: OverlayTriggerState;
    name?: string;
  } & Omit<AriaPopoverProps, "popoverRef">,
) => {
  const ref = useRef<HTMLDivElement>(null);
  const { state, children } = props;
  const { popoverProps, underlayProps } = usePopover(
    {
      ...props,
      popoverRef: ref,
    },
    state,
  );

  return (
    <Overlay>
      <div
        {...underlayProps}
        css={{
          position: "fixed",
          ...cssFns.inset("0"),
        }}
      />
      <div
        {...popoverProps}
        ref={ref}
        css={{
          ...cssFns.margin("8px", "0"),
        }}
        data-popover
      >
        <DismissButton onDismiss={state.close} />
        <MaxHeightContext.Provider value={popoverProps.style?.maxHeight}>
          {children}
        </MaxHeightContext.Provider>
        <DismissButton onDismiss={state.close} />
      </div>
    </Overlay>
  );
};
